import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface SendBatPersonalField {
  name: string;
  value: string;
}

export interface SendBatPayload {
  channel: 'EMAIL' | 'SMS';
  message: string;
  recipients: string[];
  name?: string;
  sender?: string;
  sendDate?: string;
  fields?: SendBatPersonalField[];
  object?: string;
  autocomplete?: boolean;
}

// Appelle /api/sendBat (BatController côté backend) : envoie un email/SMS de test ("BAT")
// avec les champs de personnalisation renseignés manuellement pour cette prévisualisation.
export const useSendBat = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendBat = useCallback(
    async (payload: SendBatPayload): Promise<boolean> => {
      if (!isReady) return false;
      setLoading(true);
      setError(null);
      try {
        await authFetch('/sendBat', {
          method: 'POST',
          body: JSON.stringify(payload),
        });
        return true;
      } catch (err) {
        setError(err instanceof Error ? err.message : "Erreur lors de l'envoi du BAT");
        return false;
      } finally {
        setLoading(false);
      }
    },
    [authFetch, isReady]
  );

  return { sendBat, loading, error };
};
